<div class="share-feedback-messages box_default box_white" [ngClass]="{'no-messages' : messagesList!=null && messagesList.length==0}">
    <header>
        <h3>FEEDBACK</h3>
    </header>
    <!-- TODO pending to set post urls correctly -->
    <div class="feedback-messages-form" *ngIf="addMessage">
        <core-message-add
            [context]="context"
            [user]="user"
            [action]="messageAddUrl"
            (onSaved)="saveMessage($event)">
        </core-message-add>
    </div>
    <div class="loader" [hidden]="status != STATUS_LOADING">
        <div class="dimmed"  >
            <div class="dimmed_avatar"></div>
            <div class="dimmed_info">
                <div class="dimmed_title"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
        <div class="dimmed">
            <div class="dimmed_avatar"></div>
            <div class="dimmed_info">
                <div class="dimmed_title"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
    </div>
    
    <!-- messages list -->
    <article *ngIf="messagesList != null" class="messages-section-main">

        <ul class="feedback-message-list" *ngIf="messagesList.length > 0">
            <li class="messages-timeline-item" *ngFor="let vmessage of messagesList | sortBy: 'date' : 'desc'; let i = index">
                <ng-container [ngSwitch]="vmessage.type">
                    <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.TEXT_MESSAGE_TYPE">
                        <core-message
                            [message]="vmessage.message"
                            [versionShares]="vmessage.user_version_shares ? vmessage.user_version_shares : null"
                            [notesActionText]="canCreateNotes ? 'Add Notes' : 'See Notes'"
                            [notesActionStyle]="canCreateNotes ? 'add-notes' : 'see-notes'"
                            [canCreateNotes]="canCreateNotes"
                            [prefixUrl]="prefixUrl"
                            (onDelete)="onDelete.emit($event)"
                        ></core-message>
                    </ng-template>

                    <!-- Message of uploaded version actions -->
                    <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.UPLOADED_MESSAGE_TYPE">
                        <core-message-version-share-feedback
                            [message]="vmessage"
                        ></core-message-version-share-feedback>
                    </ng-template>

                    <!-- Message of approved/rejected actions -->
                    <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.APPROVAL_MESSAGE_TYPE">
                        <core-message-version-share-feedback
                            [message]="vmessage"
                        ></core-message-version-share-feedback>
                    </ng-template>
                </ng-container>
                
                
            </li>
        </ul>
        <article *ngIf="messagesList.length==0" class="message-not-content">
            <core-helpers-box-alert-message-icon
            [text]="'There are currently no messages.'"
            [icon]="'no_messages'"
            ></core-helpers-box-alert-message-icon>
        </article>
    </article>
</div>


